// @flow
import React from 'react';
import Slide from './Slide';
import type { Props as SlideProps } from './Slide';
import Slider from './Slider';

type Props = {
  classes: Object,
  slides: Array<SlideProps>,
  carouselAutoplaySpeed: string,
  appDownload?: {
    url: string;
    iosStoreLink: string;
    iosAppLink: string;
    androidStoreLink: string;
    androidAppLink: string;
    androidApkLink: string;
  };
}

export default function HomepageCarousel(props: Props) {
  const { slides, controlsEnabled, carouselAutoplaySpeed, appDownload } = props;

  // Remove 'hidden' slides
  const shownSlides = slides?.filter(slide => slide && !slide.hidden) || [];

  return (
    <Slider controlsEnabled={controlsEnabled} carouselAutoplaySpeed={carouselAutoplaySpeed}>
      {
        shownSlides
          .map((slide) => (
            // react-slick clones the elements so keys are not reliable
            // eslint-disable-next-line react/jsx-key
            <Slide {...slide} appDownload={appDownload} />
        ))
      }
    </Slider>
  );
}
